const routeMain = () => "/contacts";

export default routeMain;
